export default "__VITE_ASSET__af417b63__"